import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { unmarkAsWixStudioAccount } from '../../../api/StudioWorkspaceService/unmarkAsWixStudioAccount'
import { WixMobileSplit as WixMobileSplitUnwrapped } from './WixMobileSplit'

type WixMobileSplitProps = {}

export const WixMobileSplit: FC<WixMobileSplitProps> = props => {
  return (
    <WixMobileSplitUnwrapped
      markAsWixStudioAccount={markAsWixStudioAccount}
      unmarkAsWixStudioAccount={unmarkAsWixStudioAccount}
      {...props}
    />
  )
}
